export const companyPages = [
  {
    slug: "about",
    seoTitle: "About Aliwer | Security Engineering & Technology",
    seoDescription:
      "Aliwer is a technology systems and cybersecurity consulting company evolving into a security engineering firm and digital platform.",
    title: "About Aliwer",
    intro:
      "Aliwer is a technology systems and cybersecurity consulting company. We help organizations assess risk, secure systems, govern technology, and continuously prove their security posture — and we build AI security products, BArecord and SecureDesk.",
    sections: [
      { heading: "Mission", body: "Secure the systems that run the world — by making strong security practical, measurable, and continuous." },
      { heading: "What we do", body: "Consulting across assessment, engineering, cloud, AI, compliance, and managed security, delivered through a vetted expert ecosystem." },
      { heading: "Leadership & ownership", body: "Aliwer LLC was founded and is owned by Lorenzo Openito (Founder & CEO). Yves Bwansa serves as Chief Operating Officer." },
      { heading: "Where we're going", body: "Evolving from a consulting-first company into a security engineering firm plus digital platform, with our assessment platform as the product engine." },
    ],
    cta: { label: "Explore our method", to: "/company/methodology" },
  },
  {
    slug: "methodology",
    seoTitle: "Aliwer Method | Assess, Design, Protect, Monitor, Prove",
    seoDescription:
      "The Aliwer Method: a five-stage model to assess risk, design controls, protect systems, monitor continuously, and prove security posture.",
    title: "The Aliwer Method",
    intro:
      "Every engagement and product follows one model: Assess → Design → Protect → Monitor → Prove. It keeps security practical, measurable, and continuous.",
    sections: [
      { heading: "1. Assess", body: "Understand your environment and risk. Identify and prioritize gaps by real business impact." },
      { heading: "2. Design", body: "Architect controls and remediation that fit your systems, team, and constraints." },
      { heading: "3. Protect", body: "Implement and harden — engineering fixes, not just recommendations." },
      { heading: "4. Monitor", body: "Continuously detect and respond with monitoring tuned to your environment." },
      { heading: "5. Prove", body: "Demonstrate posture with evidence, reporting, and audit-ready documentation." },
    ],
    cta: { label: "Request a security assessment", to: "/contact" },
  },
  {
    slug: "partners",
    seoTitle: "Aliwer Security & Technology Partner Network",
    seoDescription:
      "Join the Aliwer partner network — vetted independent security and technology experts delivering client outcomes.",
    title: "Partner Network",
    intro:
      "Aliwer delivers through a network of vetted independent experts. Partners engage as independent contractors and take on specialized work across our service lines.",
    sections: [
      { heading: "Who we work with", body: "Experienced security and technology practitioners across assessment, engineering, cloud, AI, compliance, and managed security." },
      { heading: "How it works", body: "Apply through the partner portal. Accepted partners engage as independent contractors under a separate written agreement." },
      { heading: "Why partner with Aliwer", body: "Meaningful engagements, a trusted brand, and a delivery model built around quality and accountability." },
    ],
    cta: { label: "Apply to the partner network", to: "/partner" },
  },
  {
    slug: "careers",
    seoTitle: "Careers at Aliwer | Cybersecurity & Technology",
    seoDescription:
      "Explore opportunities to work with Aliwer in cybersecurity and technology through our partner network and future roles.",
    title: "Careers at Aliwer",
    intro:
      "We're building a security engineering company and platform. Today, most opportunities come through our independent partner network.",
    sections: [
      { heading: "Partner opportunities", body: "The fastest way to work with us is via the partner network — flexible, project-based engagements for experienced practitioners." },
      { heading: "Future roles", body: "As we grow the platform, we'll open dedicated roles across engineering, product, and security operations." },
    ],
    note: "[Placeholder] Open roles will be listed here as they become available.",
    cta: { label: "Join the partner network", to: "/partner" },
  },
];
